/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_Not_InvitedInputs */



/**
* | output |
* | --- |
* | "Your company account is fine, but this address has no invitation to the workspace yet. Ask your admin to invite you, then sign in again." |
*
* @param {Signin_Sso_X15_Not_InvitedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_not_invited = /** @type {((inputs?: Signin_Sso_X15_Not_InvitedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_Not_InvitedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your company account is fine, but this address has no invitation to the workspace yet. Ask your admin to invite you, then sign in again.")
});